import React from 'react';

function WelcomePage() {
    return (
        <div style={{ marginTop: '35px' }}> 
            <div className="d-flex  flex-column justify-content-start align-items-center">
                <div className="w-75">
                    <p className=' welcome-list fw-semibold'>
                        Here you will help manage a client module so that you can help coordinate services for a specific client group.
                    </p>
                    <p className=' welcome-list'>
                        Create your profile now!
                    </p>
                </div>
            </div>
        </div>
    );
}

export default WelcomePage;
